<template>
    <div class="maintenance-page">
      <h1>Estamos em manutenção!</h1>
      <p>Volte mais tarde.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "Maintenance",
  };
  </script>
  
  <style scoped>
  .maintenance-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    background-color: #f8f9fa;
    color: #333;
  }
  </style>
  